// oxlint-disable max-lines
import { gql } from '@apollo/client';

export const ARBEITSZEIT_UPDATE = gql`
  mutation ArbeitszeitUpdate(
    $arbeitszeitUpdateInput: UpdateArbeitszeitenInput!
    $arbeitszeitId: String!
  ) {
    updateArbeitszeit(
      arbeitszeitUpdateInput: $arbeitszeitUpdateInput
      arbeitszeitId: $arbeitszeitId
    ) {
      ... on Arbeitszeiten {
        datum
        konflikte {
          konflikt
          id
        }
        termin {
          beginn
          ende

          beschreibung
          bildName
          bildUrl
          titel
          wiederholung
          id
        }
        zuschlaege {
          name
          prozent
          betrag {
            ... on arbeitszeiten_zuschlaege_betrag {
              currency
              betrag
            }
            ... on arbeitszeiten_zuschlaege_noAccess {
              message
            }
          }
          dauer
        }
        bemerkung
        rechtshinweise {
          name
          art
          backgroundcolor
        }
        id
        pauseneinstellung
        pausen {
          art
          ende
          bezahlt
          dauer
          beginn
        }
        arbeitsbereich {
          markierung
          id
          name
        }
        mitarbeiter {
          vorname
          nachname
          id
          extern
        }
        dienstgaenge {
          beginn
          ende
          dauer
          art
          bezahlt
        }
      }
      ... on ArbeitszeitUpdateArbeitsbereichNotFound {
        type
        message
      }
      ... on UnknownError {
        type
        message
      }
      ... on ArbeitszeitUpdateArbeitszeitNotFound {
        type
        message
      }
      ... on ArbeitszeitUpdateBeginnVorEnde {
        type
        message
      }
      ... on ArbeitszeitUpdateIdArbeitsbereichNull {
        type
        message
      }
      ... on ArbeitszeitUpdateInvalidPauseDauer {
        type
        message
      }
      ... on ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich {
        type
        message
      }
      ... on ArbeitszeitUpdateManagerNotFound {
        type
        message
      }
      ... on ArbeitszeitUpdateMonatAbgeschlossen {
        type
        message
      }
      ... on ArbeitszeitUpdateOtherValidationError {
        type
        message
      }
      ... on ArbeitszeitUpdateStaleState {
        type
        message
      }
    }
  }
`;

export const ARBEITSZEIT_CREATE = gql`
  mutation ArbeitszeitCreate(
    $arbeitszeitCreateInput: CreateArbeitszeitenInput2!
    $mitarbeiterId: String!
    $standortId: String!
    $datum: Date!
  ) {
    createArbeitszeit(
      arbeitszeitCreateInput: $arbeitszeitCreateInput
      mitarbeiterId: $mitarbeiterId
      standortId: $standortId
      datum: $datum
    ) {
      ... on Arbeitszeiten {
        id
        datum
      }
      ... on ArbeitszeitCreateEndeVorBeginn {
        type
        message
      }
      ... on UnknownError {
        type
        message
      }
      ... on ArbeitszeitCreateManagerHasNoAccessToArbeitsbereich {
        type
        message
      }
      ... on ArbeitszeitCreateManagerNotFound {
        type
        message
      }
      ... on ArbeitszeitCreateMissingValues {
        type
        message
      }
      ... on ArbeitszeitCreateMonatAbgeschlossen {
        type
        message
      }
      ... on ArbeitszeitCreateOtherValidationError {
        type
        message
      }
      ... on ManagerHasRoleArbeitszeitNurHeuteBearbeiten {
        type
        message
      }
    }
  }
`;

export const ARBEITSZEIT_DELETE = gql`
  mutation ArbeitszeitDelete($arbeitszeitId: String!) {
    deleteArbeitszeit(arbeitszeitId: $arbeitszeitId) {
      ... on Arbeitszeiten {
        id
        datum
        bemerkung
        beginn
        ende
        pauseneinstellung
        pausen {
          art
          ende
          bezahlt
          dauer
          beginn
        }
        arbeitsbereich {
          __typename
          markierung
          id
          name
        }
        mitarbeiter {
          vorname
          nachname
          id
        }
      }
      ... on ArbeitszeitNotFound {
        type
        message
      }
      ... on ArbeitszeitManagerNotFound {
        type
        message
      }
      ... on ArbeitszeitMonatAbgeschlossen {
        type
        message
      }
      ... on ManagerHasRoleArbeitszeitNurHeuteBearbeiten {
        type
        message
      }
      ... on UnknownError {
        type
        message
      }
    }
  }
`;

export const DIENSTPLANUEBERNAHME_UPDATE = gql`
  mutation DienstplanuebernahmeUpdate(
    $input: [UpdateDienstplanuebernahmeInput!]!
  ) {
    updateDienstplanuebernahme(updateDienstplanuebernahmeInput: $input) {
      id
    }
  }
`;

export const ARBEITSZEITANTRAG_ABLEHNEN = gql`
  mutation arbeitszeitantragAblehnen($input: ArbeitszeitantragAblehnenInput!) {
    arbeitszeitantragAblehnen(input: $input) {
      ... on ArbeitszeitantragAblehnen {
        idAntrag
        bemerkungVorgesetzter
      }
      ... on ArbeitszeitantragAblehnenError {
        type
        message
      }
    }
  }
`;

export const ARBEITSZEITANTRAG_GENEHMIGEN = gql`
  mutation arbeitszeitantragGenehmigen(
    $input: ArbeitszeitantragGenehmigenInput!
  ) {
    arbeitszeitantragGenehmigen(input: $input) {
      ... on ArbeitszeitantragGenehmigen {
        idAntrag
        bemerkungVorgesetzter
      }
      ... on ArbeitszeitantragGenehmigenError {
        type
        message
      }
    }
  }
`;

export const ARBEITSZEIT_CREATE_MANY = gql`
  mutation ArbeitszeitCreateMany($input: [CreateArbeitszeitenBulkInput!]!) {
    createManyArbeitszeiten(input: $input) {
      input {
        arbeitsbereichId
        beginn
        datum
        ende
        mitarbeiterId
        standortId
      }
      result {
        ... on Arbeitszeiten {
          id
          datum
        }
        ... on ArbeitszeitCreateEndeVorBeginn {
          type
          message
        }
        ... on UnknownError {
          type
          message
        }
        ... on ArbeitszeitCreateManagerHasNoAccessToArbeitsbereich {
          type
          message
        }
        ... on ArbeitszeitCreateManagerNotFound {
          type
          message
        }
        ... on ArbeitszeitCreateMissingValues {
          type
          message
        }
        ... on ArbeitszeitCreateMonatAbgeschlossen {
          type
          message
        }
        ... on ArbeitszeitCreateOtherValidationError {
          type
          message
        }
        ... on ManagerHasRoleArbeitszeitNurHeuteBearbeiten {
          type
          message
        }
      }
    }
  }
`;

export const ABWESENHEIT_DELETE = gql`
  mutation Arbeitszeiten_AbwesenheitDelete($id: String!) {
    arbeitszeiten_abwesenheiten_delete(id: $id) {
      abwesenheit {
        id
      }
      error {
        message
        ... on Arbeitszeiten_AbwesenenheitNotFound {
          id
        }
      }
    }
  }
`;

export const UPDATE_ARBEITSZEIT_TERMIN_VERKNUEPFUNG = gql`
  mutation updateArbeitszeitTerminVerknuepfung(
    $arbeitszeitId: String!
    $terminId: String
  ) {
    updateArbeitszeitTerminVerknuepfung(
      arbeitszeitId: $arbeitszeitId
      terminId: $terminId
    ) {
      ... on Arbeitszeiten_TerminMutationResponse {
        termin {
          id
          titel
          beschreibung
          bildName
          bildUrl
          wiederholung
        }
      }
      error {
        message
      }
    }
  }
`;

export const UPDATE_MANAGER_SETTINGS = gql`
  mutation updateManagerSettings(
    $settings: manager_managerSettingsUpdateInput!
  ) {
    manager_UpdateManagerSettings(managerSettings: $settings) {
      __typename
    }
  }
`;
